import Typography from '@alltrails/core/components/Typography';
import type { Report } from '../../types';
import styles from './styles/styles.module.scss';

type ReportRowProps = {
  report: Report;
};

export default function ReportRow({ report }: ReportRowProps) {
  return (
    <div className={styles.container}>
      <Typography component="div" variant="heading200">
        {report.label}
      </Typography>
      <Typography component="div" variant="text200">
        {report.description}
      </Typography>
    </div>
  );
}
